module.exports = __webpack_public_path__ + "static/media/search.e62b8371.svg";